<template>
    <div ref="orderProducts">
        <div class="row" v-if="selectedItem">
            <div class="col-12">
                <label for="productpicker">{{$t('ORDERS.chooseProduct')}}</label>
                <multiselect v-model="editedItem"
                             :options="products"
                             :multiple="false"
                             :close-on-select="true"
                             :hide-selected="true"
                             :preserve-search="true"
                             id="productpicker"
                             selectLabel=""
                             deselectLabel=""
                             placeholder="Product id"
                             :custom-label="customLabel"
                             trackBy="id">
                    <template slot="tag" slot-scope="props">
                    <span class="custom__tag">
                        <span>{{ props.option.type }} - {{props.option.id}}</span>
                        <span class="custom__remove" @click="props.remove(props.option)">
                            ❌
                        </span>
                    </span>
                    </template>
                </multiselect>
            
            </div>
            <div class="col-12">
                <layout-selection :selectedLayout.sync="editedItem.layout"
                                  :options="editedItem.availableLayouts || []"/>
            </div>
            <div class="col-12" v-if="edited">
                <div class="form-group">
                    <label class="form-label">{{$t('ORDERS.bulk')}}: </label>
                    <input type="checkbox" v-model="bulkEdit">
                </div>
                <p v-if="itemCopy">
                    {{bulkEdit ? $t(
                    'ORDERS.allProductsWillChange', {id: itemCopy.id, editedId: editedItem.id})
                    : $t('ORDERS.productsWillChange', {id: itemCopy.id, editedId: editedItem.id}) }}
                </p>
                <button class="btn btn-sm btn-cph-primary-outline"
                        @click="save">
                    {{$t('UI.save')}}
                </button>
            </div>
        </div>
        <table  class="table table-striped table-responsive-md">
            <thead>
            <tr>
                <th>#</th>
                <th>{{$t('COMMON.type') | capitalize}}</th>
                <th>{{$t('COMMON.id') | capitalize}}</th>
                <th>{{$t('COMMON.format') | capitalize}}</th>
                <th>{{$t('COMMON.quantity') | capitalize}}</th>
                <th>{{$t('COMMON.unitPrice') | capitalize}}</th>
                <th>{{$t('COMMON.totalPrice') | capitalize}}</th>
                <th>{{$t('COMMON.layout') | capitalize}}</th>
                <th>{{$t('COMMON.surface') | capitalize}}</th>
                <th>{{$t('COMMON.printed') | capitalize}}</th>
                <th>{{$t('COMMON.rendered') | capitalize}}</th>
                <th>{{$t('COMMON.status') | capitalize}}</th>
            </tr>
            </thead>
            <tbody>
            <OrderTableItem  v-for="(item, index) in extractCartItems"
                             :class="[
                                'table-row',
                                {'row-active': selectedIndex === index}
                             ]"
                             :key="item.id + index"
                             :item="item" :index="index"
                             :price="getProductPrice(item, prices)"
                             @click.native="selectOrderItem(item, index)"
                             v-if="(index < (currentPage - 1) * 10 + 10
                                 && index >= (currentPage - 1 ) * 10)"/>
            </tbody>
        </table>
        <pagination :currPage.sync="currentPage"
                    :pagesLength="calculateNumberOfPages()"></pagination>
    </div>
</template>

<script type="text/babel">
import {mapGetters} from 'vuex';
import AnalyticsService from '../../Analytics/AnalyticsService';
import Filters from '../../../../mixins/CphFilters.vue';
import Pagination from '../../../Shared/CphPagination.vue';
import OrderTableItem from './OrderTableItem';
import FormInput from '../../../Shared/UI/Form/FormInput.vue';
import Multiselect from 'vue-multiselect';
import LayoutSelection from '../../Templates/Workspace/Area/Left/LayoutSelection';
export default {
    name: 'OrderDetails',
    data () {
        return {
            selectedItem: null,
            edited: false,
            editedItem: {},
            itemCopy: null,
            itemId: '',
            currentPage: 1,
            selectedId: null,
            bulkEdit: false,
            selectedIndex: null
        };
    },
    props: {
        cart: {
            type: Array,
            required: true
        }
    },
    components: {
        OrderTableItem,
        Pagination,
        FormInput,
        LayoutSelection,
        Multiselect
    },
    mixins: [Filters, AnalyticsService],
    computed: {
        ...mapGetters({prices : 'getAllPrices', products: 'getProducts', layouts: 'getLayouts'}),
        extractCartItems () {
            let result = [];
            this.cart.forEach(item => {
                item.products.forEach(product => {
                    result.push(product);
                });
            });
            return result;
        }
    },
    methods: {
        customLabel ({ type, id, formats }) {
            return `${type} – ${formats[0].id} - ${id}`;
        },
        calculateNumberOfPages () {
            return Math.ceil(this.extractCartItems.length / 10);
        },
        selectOrderItem (item, index) {
            this.selectedIndex = index;
            this.itemCopy = JSON.parse(JSON.stringify(item));
            this.itemId = this.itemCopy.id;
            this.selectedItem = {...item};
            this.editedItem = this.selectedItem;
            this.selectedId = this.selectedItem.cartItemId;
            this.edited = true;
        },
        save () {
            this.$emit('save', {cart: this.cart});
        },
        updateCartItems ({id, formats, availableLayouts, type, layout}, bulkFalseFlag) {
            let comparedItemId = bulkFalseFlag ? this.editedItem.id : this.itemId;
            if(!layout) {
                layout = availableLayouts ? availableLayouts[0] : {};
                this.editedItem.layout = layout;
            }
            this.cart.forEach(item => {
                item.products.forEach(product => {
                    if((bulkFalseFlag || this.bulkEdit || product.cartItemId === this.selectedId) && product.id === comparedItemId) {
                        product = Object.assign(product, {id, formats, availableLayouts, type, layout});
                    }
                });
            });
            if(this.bulkEdit || bulkFalseFlag) {
                this.itemId = id;
            }
            this.$emit('update:cart', this.cart);
        }
    },
    mounted () {
        this.$watch('editedItem', (newVal) => {
            if(!newVal) {
                return;
            }
            this.updateCartItems(newVal, false);
        }, {deep: true, immediate: true});
    
        this.$watch('bulkEdit', (val) => {
            this.updateCartItems(val ? this.editedItem : this.itemCopy, !val);
        });
    }
};

</script>
